import camelCase from 'lodash/camelCase';

export const findAncestor = (elm, target) => {
    if (!elm || typeof elm === 'undefined') {
        return null;
    }

    let targetName = target;

    if (targetName.includes('data-')) {
        targetName = camelCase(targetName.replace('data-', ''));
    }

    let node = elm;

    while (node && !(
        node.classList?.contains(targetName)
        || node.id === targetName
        || typeof node.dataset[targetName] !== 'undefined'
    )) {
        node = node.parentNode;

        if (typeof node?.classList === 'undefined' && typeof node?.id === 'undefined') {
            return null;
        }
    }

    return node;
};
